import React from 'react';
import PropTypes from 'prop-types';
import GenericButton from '../common/GenericButton';
import { GEOMAP_EXPORT_WARNING_MSG } from "./GeoMapConstant";
import warningImage from '../../images/warning_amber_24px.png';
import { exportFileTitle } from '../../util/CommonUtils';

class GeoMapExportForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: exportFileTitle('GeoMapping'),
      fileType: 'xlsx',
    };
  }

  getFileName = () => {
    const { base } = this.props;
    const baseName = base.length ? base[0].title : 'StudyUniverse';
    return `MRI-Simmons_Geo_Mapping_${baseName}_${this.getTimeStamp()}`;
  }

  getRowHeadersAndExpressions = items => {
    return {
      rowHeaderList: items.map(r => r.g),
      rowExpressionList: items.map(r => r.e),
    };
  }

  // MM-DD-YYYY_HHMMSS
  getTimeStamp = () => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const year = now.getFullYear();
    const hours = `0${now.getHours()}`.slice(-2);
    const minutes = `0${now.getMinutes()}`.slice(-2);
    const seconds = `0${now.getSeconds()}`.slice(-2);

    return `${month}-${day}-${year}_${hours}${minutes}${seconds}`;
  }

  render() {
    const { fileName, fileType } = this.state;
    return (
      <div id="geoMapExportForm" className="row" data-test="geoExportForm">
        <div className="columns">
          <h5>File name</h5>
          <input
            type="text"
            id="geoMapExportFileName"
            value={this.state.fileName}
            onChange={e => this.setState({ fileName: e.target.value })}
          />
        </div>
        <div className="columns margin-top-10">
          <input
            type="radio"
            id="geoMapExportExcel"
            name="geoMapExportType"
            value="xlsx"
            checked={this.state.fileType === 'xlsx'}
            onChange={e => this.setState({ fileType: e.target.value })}
          />
          <label htmlFor="geoMapExportExcel">
            <b>One Excel workbook</b> (geography types on separate worksheets)
          </label>
        </div>
        <div className="columns">
          <input
            type="radio"
            id="geoMapExportCsv"
            name="geoMapExportType"
            value="csv"
            checked={this.state.fileType === 'csv'}
            onChange={e => this.setState({ fileType: e.target.value })}
          />
          <label htmlFor="geoMapExportCsv">
            <b>Separate .csv files</b> (for each geography type)
          </label>
        </div>
        <div className="columns margin-top-20">
          <div className="row">
            <div className="columns small-6 text-center">
              <GenericButton
                name="Cancel"
                onBtnClick={() => this.props.closeGeoMapExportModal()}
              />
            </div>
            <div className="columns small-6 text-center">
              <GenericButton
                name="Export"
                onBtnClick={() => {
                  this.props.closeGeoMapExportModal();
                  setTimeout(
                    () => {
                      this.props.exportGeoMap(fileName, fileType);
                    }, 1000);
                }}
              />
            </div>
          </div>
        </div>
        <div>
          <span>
            <img
              className="export-warning-icon"
              src={warningImage}
              alt='warningimage'
            />
          </span>
          <span className="export-warning-msg">
            {GEOMAP_EXPORT_WARNING_MSG}</span></div>
      </div>
    );
  }
}

GeoMapExportForm.propTypes = {
  closeGeoMapExportModal: PropTypes.func,
  study: PropTypes.shape(),
  weightType: PropTypes.shape(),
  base: PropTypes.arrayOf(Object),
  target: PropTypes.arrayOf(Object),
  geoMapData: PropTypes.shape(),
  exportGeoMap: PropTypes.func,
  selectedGeoMapTabIndex: PropTypes.number,
  originalTitles: PropTypes.instanceOf(Object),
};

export default GeoMapExportForm;
